import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { VersionFooter } from './VersionFooter';
import { useLayoutStore } from '@/store/layoutStore';
import { useAuth } from '@/hooks/useAuth';

/**
 * Top-level authenticated layout — Header + Sidebar + main content area.
 * Content area is offset 240px from the left (sidebar width) and 56px from the top (header height).
 */
export function Layout() {
  const sidebarOpen = useLayoutStore((s) => s.sidebarOpen);
  const toggleSidebar = useLayoutStore((s) => s.toggleSidebar);
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-white">
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      <Header onLogout={logout} user={user ?? undefined} onToggleSidebar={toggleSidebar} />
      <main className="min-w-0 px-4 pb-8 pt-20 md:ml-[240px] md:px-8">
        <Outlet />
      </main>
      <VersionFooter />
    </div>
  );
}
